import { render, staticRenderFns } from "./supInfo.vue?vue&type=template&id=4741064d&"
import script from "./supInfo.vue?vue&type=script&lang=js&"
export * from "./supInfo.vue?vue&type=script&lang=js&"
import style0 from "./supInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports